import React, { FC, useContext } from 'react';

import { GlobalContext } from '../../../../../../store';

import AutoComplete from '../../../../../../components/AutoComplete';
import Button from '../../../../../../components/Button';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../../../components/Forms';
import Input from '../../../../../../components/Input';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { defaultValues } from './Utils/AddPlayerFormDefaultValues';
import { validations } from './Utils/AddPlayerFormValidations';

interface IProps {
  onClose?: () => void;
}

const AddPlayerForm: FC<IProps> = props => {
  const { onClose } = props;

  const {
    actions: {
      adminEventEnrollments: { addGuest },
      notifications: { push: pushNotification }
    },
    adminEvents
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const flights = adminEvents.current ? adminEvents.current.flights : [];

  const onGuestPlayerAdd = async (guest: any): Promise<any> =>
    clubId && eventId && roundId ? addGuest(clubId, eventId, roundId, guest) : null;

  const onSubmit = async (data: any) => {
    const response = await onGuestPlayerAdd({ ...data, flight: data.flight.value, handicap: 0 });

    if (!response.errors) {
      await pushNotification({
        status: 'unread',
        text: 'Invitation successful was sent',
        type: 'success'
      });

      if (onClose) {
        onClose();
      }
    } else {
      await pushNotification({
        status: 'unread',
        text: 'The guest could not be invited',
        type: 'error'
      });
    }
  };

  const options = flights.map(flight => ({ label: flight.name, value: String(flight.id) }));

  return (
    <FormProvider defaultValues={defaultValues} onSubmit={onSubmit} validations={validations}>
      <FormConsumer>
        {({ values, formActions: { setValue }, errors }: IFormAttributes) => (
          <div className="add-player-form">
            <Input
              label="FIRST NAME"
              id="first-name"
              type="text"
              value={values.user.firstName}
              onChange={setValue('user.firstName')}
              hasError={errors['user.firstName']}
              errorMessage="First Name cannot be empty"
              fullWidth={true}
            />

            <Input
              label="LAST NAME"
              id="last-name"
              type="text"
              value={values.user.lastName}
              onChange={setValue('user.lastName')}
              hasError={errors['user.lastName']}
              errorMessage="Last Name cannot be empty"
              fullWidth={true}
            />

            <Input
              label="EMAIL"
              id="email"
              type="email"
              value={values.user.email}
              onChange={setValue('user.email')}
              hasError={errors['user.email']}
              errorMessage={'You must provide a valid email'}
              fullWidth={true}
            />

            <AutoComplete
              value={values.flight}
              options={options}
              onChange={setValue('flight')}
              hasError={errors.flight}
              placeholder="SELECT FLIGHT"
            />

            <Input
              label="GHIN NUMBER"
              id="ghin-number"
              type="number"
              value={values.user.profile.ghinNumber}
              onChange={setValue('user.profile.ghinNumber')}
              hasError={errors['user.profile.ghinNumber']}
              fullWidth={true}
            />

            <div className="form-actions">
              <Button
                className="register-next-button"
                color="primary"
                type="button"
                onClick={onClose}
                variant="outlined"
              >
                CANCEL
              </Button>

              <Button
                className="register-next-button"
                color="primary"
                disabled={errors.FORM}
                type="submit"
                variant="contained"
              >
                SAVE
              </Button>
            </div>
          </div>
        )}
      </FormConsumer>
    </FormProvider>
  );
};

export default AddPlayerForm;
